import React from "react";
import { connect } from "react-redux";
import { database } from "../../app-database";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo
	};
};

class ContratoDatosPersonales extends React.Component{

	state = {
		aviso : ""
	}

	componentWillMount = () =>{
		var $this = this;
		database.ref("/documentacion/aviso").once("value").then(function(data){
			$this.setState({ "aviso" : data.val() });  
		});
	}
	
	render() {
		const { aviso } = this.state;
		const newAviso = aviso.replace(/___________________________________________________/g,"")
		const { dispositivo } = this.props
		return (
			<div className='text-content'>
				<div className="datos-wrap row" style={{"paddingTop":"8px"}}>
					<div className="col-xs-12">
						<h3 className={dispositivo === "app" ? "title-contract": ""}>Ley Federal de Protección de Datos Personales en Posesión de los Particulares</h3><br/>
						<div dangerouslySetInnerHTML={{__html: newAviso}} className={dispositivo === "app" ? "body-contract" : "txt-gray"}></div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, {})(ContratoDatosPersonales);


// WEBPACK FOOTER //
// ./src/movil/contratos/contratosDP.cmpt.js